import React, { useEffect } from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'Gizlilik Politikası | akarma';
  }, []);

  return (
    <div className="privacy-policy pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Shield size={64} className="mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Gizlilik Politikası</h1>
            <p className="text-xl opacity-90">Kişisel verilerinizin korunması bizim için önemlidir</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-8">
                Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900">1. Giriş</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                akarma Eğitim ve Danışmanlık Merkezi olarak, kişisel verilerinizin güvenliği ve gizliliği bizim için 
                son derece önemlidir. Bu Gizlilik Politikası, akarma.com.tr web sitesini ("Site") ziyaret ettiğinizde 
                ve hizmetlerimizi kullandığınızda kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını 
                ve korunduğunu açıklamaktadır.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Bu politika, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili mevzuata uygun olarak hazırlanmıştır.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">2. Veri Sorumlusu</h2>
              <div className="bg-akarma-blue bg-opacity-5 p-6 rounded-xl mb-6">
                <p className="text-gray-700 mb-2"><strong>Veri Sorumlusu:</strong> akarma Eğitim ve Danışmanlık Merkezi</p>
                <p className="text-gray-700 mb-2"><strong>Adres:</strong> Etiler Mahallesi Uçaksavar Sitesi Muharipler Sokak No:9 D:2, Etiler / Beşiktaş / İstanbul</p>
                <p className="text-gray-700 mb-2"><strong>E-posta:</strong> info@akarma.com.tr</p>
                <p className="text-gray-700"><strong>Telefon:</strong> +90 212 263 3484</p>
              </div>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">3. Toplanan Kişisel Veriler</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Site'yi kullanırken aşağıdaki kişisel verileriniz toplanabilir:
              </p>

              <h3 className="text-2xl font-semibold mb-4 text-gray-800">3.1. İletişim Formu Verileri</h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Ad Soyad</li>
                <li>E-posta adresi</li>
                <li>Telefon numarası</li>
                <li>Mesaj içeriği</li>
                <li>İletişim konusu</li>
              </ul>

              <h3 className="text-2xl font-semibold mb-4 text-gray-800 mt-8">3.2. Otomatik Olarak Toplanan Veriler</h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>IP adresi</li>
                <li>Tarayıcı türü ve sürümü</li>
                <li>Ziyaret edilen sayfalar</li>
                <li>Ziyaret tarihi ve saati</li>
                <li>Cihaz bilgileri</li>
                <li>Yönlendirme kaynağı (referrer URL)</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">4. Kişisel Verilerin İşlenme Amaçları</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>İletişim taleplerinize yanıt vermek</li>
                <li>Randevu taleplerini değerlendirmek ve organize etmek</li>
                <li>Hizmetlerimiz hakkında bilgi sağlamak</li>
                <li>Müşteri ilişkileri yönetimi</li>
                <li>Site'nin işlevselliğini geliştirmek</li>
                <li>Kullanıcı deneyimini iyileştirmek</li>
                <li>İstatistiksel analizler yapmak</li>
                <li>Yasal yükümlülükleri yerine getirmek</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">5. Kişisel Verilerin İşlenme Hukuki Sebepleri</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kişisel verileriniz KVKK'nın 5. ve 6. maddelerinde belirtilen aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Açık rızanız</li>
                <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması</li>
                <li>Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi</li>
                <li>Meşru menfaatlerimiz</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">6. Kişisel Verilerin Aktarılması</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Kişisel verileriniz, yalnızca yukarıda belirtilen amaçların gerçekleştirilmesi için gerekli olduğu ölçüde 
                ve KVKK'da öngörülen güvenlik standartlarına uygun olarak üçüncü kişilerle paylaşılabilir:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Hizmet sağlayıcılar (web hosting, e-posta servisleri)</li>
                <li>Yasal merciler (yasal zorunluluk halinde)</li>
                <li>İş ortakları (yalnızca açık rızanızla)</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-6">
                Verileriniz, yurt dışına aktarılmayacaktır. Yurt dışına aktarım gerektiği takdirde, açık rızanız alınacaktır.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">7. Çerezler (Cookies)</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Site'miz, kullanıcı deneyimini iyileştirmek ve Site'nin işlevselliğini sağlamak için çerezler kullanmaktadır.
              </p>
              <h3 className="text-2xl font-semibold mb-4 text-gray-800">Kullanılan Çerez Türleri:</h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li><strong>Zorunlu Çerezler:</strong> Site'nin temel işlevlerini yerine getirmek için gereklidir</li>
                <li><strong>Performans Çerezleri:</strong> Site performansını ölçmek için kullanılır</li>
                <li><strong>İşlevsellik Çerezleri:</strong> Tercihlerinizi hatırlamak için kullanılır</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-6">
                Tarayıcı ayarlarınızdan çerezleri yönetebilir veya silebilirsiniz. Ancak çerezleri devre dışı bırakmanız 
                durumunda Site'nin bazı özellikleri düzgün çalışmayabilir.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">8. Veri Güvenliği</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Kişisel verilerinizin güvenliğini sağlamak için teknik ve idari tedbirler almaktayız:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>SSL sertifikası ile şifreli bağlantı</li>
                <li>Güvenli sunucu altyapısı</li>
                <li>Düzenli güvenlik güncellemeleri</li>
                <li>Erişim kontrolü ve yetkilendirme</li>
                <li>Periyodik güvenlik denetimleri</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">9. Veri Saklama Süresi</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Kişisel verileriniz, işlendikleri amaç için gerekli olan süre boyunca ve yasal saklama yükümlülüklerine 
                uygun olarak saklanacaktır. Bu süre sona erdiğinde verileriniz silinir, yok edilir veya anonim hale getirilir.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">10. KVKK Kapsamındaki Haklarınız</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                <li>İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                <li>Eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
                <li>KVKK'da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme</li>
                <li>Düzeltme, silme veya yok edilme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhine bir sonuç çıkmasına itiraz etme</li>
                <li>Kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
              </ul>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">11. Başvuru Yöntemi</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle başvurabilirsiniz:
              </p>
              <div className="bg-gray-50 p-6 rounded-xl mb-6">
                <p className="text-gray-700 mb-3">
                  <strong>E-posta:</strong> info@akarma.com.tr adresine "KVKK Başvurusu" konulu e-posta göndererek
                </p>
                <p className="text-gray-700 mb-3">
                  <strong>Posta:</strong> Etiler Mahallesi Uçaksavar Sitesi Muharipler Sokak No:9 D:2, Etiler / Beşiktaş / İstanbul adresine yazılı olarak
                </p>
                <p className="text-gray-700 text-sm italic">
                  Not: Başvurularınız en geç 30 gün içinde ücretsiz olarak yanıtlanacaktır.
                </p>
              </div>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">12. Değişiklikler</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Bu Gizlilik Politikası'nda değişiklik yapma hakkımız saklıdır. Yapılan değişiklikler Site'de 
                yayınlandığı tarihte yürürlüğe girer. Önemli değişiklikler olması durumunda sizi bilgilendireceğiz.
              </p>

              <h2 className="text-3xl font-bold mb-6 text-gray-900 mt-12">13. İletişim</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Gizlilik Politikası hakkında sorularınız için:
              </p>
              <div className="bg-akarma-blue bg-opacity-5 p-6 rounded-xl">
                <p className="text-gray-700 mb-2"><strong>E-posta:</strong> info@akarma.com.tr</p>
                <p className="text-gray-700 mb-2"><strong>Telefon:</strong> +90 212 263 3484</p>
                <p className="text-gray-700"><strong>Adres:</strong> Etiler Mahallesi Uçaksavar Sitesi Muharipler Sokak No:9 D:2, Etiler / Beşiktaş / İstanbul</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;